const Joi = require("joi");

const documentsSchema = (data, isEditMode) => {
  const schema = Joi.object({
    documentTitle: Joi.string()
      .trim()
      //.pattern(new RegExp("^[a-zA-Z0-9 ]+$")) // Allow spaces in title
      .pattern(new RegExp("^(?! )[a-zA-Z0-9 ]+$"))
      .required()
      .messages({
        "string.pattern.base":
          "Please enter valid title using only alphanumeric characters.",
        "string.empty": "Please enter Title.", // Triggers when the title is empty
        "any.required": "Please enter Title", // Triggers when the title is missing
      }),

    documentName:
      // isEditMode
      //   ? Joi.string().optional().allow("") // Skip validation if in edit mode

      Joi.string()
        .required() // Ensure that the document name is required
        .pattern(/\.pdf$/) // Ensure the document name ends with ".pdf"
        .messages({
          "any.required": "Please upload Document.", // When no file is uploaded
          "string.empty": "Please upload Document.", // When the field is an empty string
          "string.pattern.base": "Please select PDF Document.", // When the file is not a PDF
          // Please select pdf document
          "string.base": "Please upload Document.", // When the file is not a PDF
        }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false, // Show all errors, not just the first one
  });
};

module.exports = documentsSchema;
